
// examPatternCreatorSvc.js
import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
// const httpURL = lstModules['local'].url + ':' + lstModules['local'].port;




function getTokenId() { return localStorage.getItem('tokenid'); }

export const getClassListSvc = (callback) => {
    const obj = { status: '', message: '' };
    axios({
        url: httpURL + '/sms/mst/cls/list',
        method: 'POST',
        params: { screenId: 1 },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === 'Success') {
            obj.lstClass = response.data.lstClass;
        }
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const savePatternSvc = (objPattern, callback) => {
    const obj = { status: '', message: '' };
    const formData = new FormData();
    formData.append('objPattern', JSON.stringify(objPattern));
    // console.log("savePatternSvc url:", 'http://192.168.1.45:8280/sms/qp_pattern/save', "payload:", objPattern);
    axios({
        url:  httpURL+'/sms/qp_pattern/save',
        method: 'POST',
        data: formData,
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("savePatternSvc response:", response.data);
        obj.status    = response.data.SvcStatus;
        obj.message   = response.data.SvcMsg;
        obj.patternId = response.data.patternId;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const getQpPatternListSvc = (clsId, callback) => {
    const obj = { status: '', message: '' };
    axios({
        url: httpURL + '/sms/qp_pattern/list',
        method: 'POST',
        params: { clsId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === 'Success') {
            obj.lstPattern = response.data.lstQpPattern;
        }
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};


export const getPatternSectionListSvc = (patternId, callback) => {
    const obj = { status: '', message: '' };
    axios({
        url: httpURL + '/sms/qp_pattern/list_pattern_section',
        method: 'POST',
        params: { patternId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("getPatternSectionListSvc response:", response.data);
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === 'Success') {
            obj.lstPatternSection = response.data.lstQpPatternSection;
        }
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const getQusMarksSvc = (callback) => {
    const obj = { status: '', message: '' };
    console.log("getQusMarksSvc url:", httpURL + '/sms/qp_pattern/list_qus_marks');
    axios({
        url: httpURL + '/sms/qp_pattern/list_qus_marks',
        method: 'POST',
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("getQusMarksSvc response:", response.data);
        obj.status     = response.data.SvcStatus;
        obj.message    = response.data.SvcMsg;
        obj.lstQusMarks = response.data.lstQusMarks;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const getQusTypeListSvc = (callback) => {
    const obj = { status: '', message: '' };
    console.log("getQusTypeListSvc url:", httpURL + '/sms/qp_pattern/list_qus_type');
    axios({
        url: httpURL + '/sms/qp_pattern/list_qus_type',
        method: 'POST',
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("getQusTypeListSvc response:", response.data);
        obj.status     = response.data.SvcStatus;
        obj.message    = response.data.SvcMsg;
        obj.lstQusType = response.data.lstQusType;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const savePatternSectionSvc =(objPatternSection, callback) =>{
     const obj = { status: '', message: '' };
     const formData = new FormData();
     formData.append('objPatternSection', JSON.stringify(objPatternSection));
    console.log("savePatternSectionSvc url:", httpURL + '/sms/qp_pattern/save_pattern_section', "payload:", objPatternSection);
      axios({
        url: httpURL + '/sms/qp_pattern/save_pattern_section',
        method: 'POST',
        data: formData,
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("savePatternSectionSvc response:", response.data);
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const deletePatternSectionSvc = (patternId, section, callback) => {
    const obj = { status: '', message: '' };
    axios({
        url: httpURL + '/sms/qp_pattern/delete_pattern_section',
        method: 'POST',
        params: { patternId, section },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const deletePatternSvc = (patternId, callback) => {
    const obj = { status: '', message: '' };
    axios({
        url: httpURL + '/sms/qp_pattern/delete',
        method: 'POST',
        params: { patternId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};

export const approvePatternSvc = (patternId, callback) => {
    const obj = { status: '', message: '' };
    console.log("approvePatternSvc url:", httpURL + '/sms/qp_pattern/approve', "patternId:", patternId);
    axios({
        url: httpURL + '/sms/qp_pattern/approve',
        method: 'POST',
        params: { patternId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    }).then((response) => {
        console.log("approvePatternSvc response:", response.data);
        obj.status  = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status  = 'Exception';
        obj.message = error;
        callback(obj);
    });
};
